<template>
    <div class="mobile-menu">
        <div class="card p-3 mb-3" v-for="(item, index) in listMenus" :key="index">
            <div class="group-menu mb-2">{{  item.groupMenu }}</div>
            <div class="child-menu d-flex flex-wrap">
                <div class="child-item col-4 d-flex flex-column align-items-center mb-3" @click="goToMenu(itemChild)" v-for="(itemChild, indexChild) in item.children" :key="indexChild">
                    <b-overlay :id="'id-' + itemChild.routerName" :show="isBusy[itemChild.routerName]" rounded="circle">
                        <b-avatar class="child-item-icon" variant="light">
                            <b-img :class="'mobile-icon ' + itemChild.iconSize" :src="`${publicPath}/img/mobile-icon/` + itemChild.icon" />
                        </b-avatar>
                    </b-overlay>
                    <div class="child-item-text mt-2 text-center">{{ itemChild.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss">
    .mobile-menu {
        background-color: #fff;
        padding: 1rem;
        padding-top: 2rem;
        
        .group-menu {
            font-size: 14px;
            font-weight: 600;
        }
       
        .child-menu {
            .child-item {
                cursor: pointer;

                .child-item-icon {
                    width: 95px;
                    height: 95px;
                }

                .mobile-icon {
                    height: 55px;
                }

                .mobile-icon.sm-icon {
                    height: 50px;
                }

                @media (max-width: 475px) {
                    .child-item-icon {
                        width: 60px;
                        height: 60px;
                    }

                    .mobile-icon {
                        height: 35px;
                    }

                    .mobile-icon.sm-icon {
                        height: 30px;
                    }
                }
            }

            .child-item:hover {
                .badge-light {
                    background-color: #c2c2c2;
                }
            }
        }
    }
</style>
<script>
    import PartGoodReceipt from '@/models/PartGoodReceipt/PartGoodReceipt';
    import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
    import PutAway from '@/models/PutAway/PutAway';
    import WorkOrderExecution from '@/models/WorkOrderExecution/WorkOrderExecution';
    import ReceiptFromProduction from '@/models/ReceiptFromProduction/ReceiptFromProduction';
    import CombineCase from '@/models/CombineCase/CombineCase';
    import PickingSupplyForSubcontract from '@/models/PickingSupplyForSubcontract/PickingSupplyForSubcontract';
    import SubcontractGoodReceipt from '@/models/SubcontractGoodReceipt/SubcontractGoodReceipt';
    import StockOpname from '@/models/StockOpname/StockOpname';
import PutawayHeader from '../../models/PutawayHeader/PutawayHeader';

    export default {
        data() {
            return {
                listMenus : [
                    {
                        groupMenu : "Material Purchase",
                        children : [
                            {
                                name : "Good Receipt",
                                icon : "good-receipt.png",
                                iconSize : "",
                                routerName : "partgoodreceipt"
                            },
                            {
                                name : "Quality Check",
                                icon : "quality-check.png",
                                iconSize : "",
                                routerName : "partpurchasequalitycontrol"
                            },
                        ]
                    },
                    {
                        groupMenu : "Production",
                        children : [
                            {
                                name : "Picking For Prod",
                                icon : "picking-for-prod.png",
                                iconSize : "",
                                routerName : "pickingsupplyforproductionindex"
                            },
                            {
                                name : "Posting",
                                icon : "posting.png",
                                iconSize : "",
                                routerName : "postingsupplyforproductionindex"
                            },
                            {
                                name : "WO Execution",
                                icon : "wo-execution.png",
                                iconSize : "sm-icon",
                                routerName : "woexecution",
                            },
                            {
                                name : "WOE List",
                                icon : "wo-execution.png",
                                iconSize : "sm-icon",
                                routerName : "workorderexecutionindex",
                            },
                            {
                                name : "Receipt For Prod",
                                icon : "receipt-for-prod.png",
                                iconSize : "sm-icon",
                                routerName : "receiptfromproduction"
                            },
                            {
                                name : "RFP List",
                                icon : "receipt-for-prod.png",
                                iconSize : "sm-icon",
                                routerName : "receiptfromproductionindex",
                            },
                            {
                                name : "Repair",
                                icon : "repair.png",
                                iconSize : "sm-icon",
                                routerName : "repairscan"
                            },
                            
                        ]
                    },
                    {
                        groupMenu : "Delivery",
                        children : [
                            {
                                name : "Finish Good QI",
                                icon : "finish-good-qi.png",
                                iconSize : "sm-icon",
                                routerName : "finishgoodqualityinspectionindex"
                            },
                            {
                                name : "Repacking",
                                icon : "repacking.png",
                                iconSize : "",
                                routerName : "repackingsearchscan"
                            },
                            {
                                name : "Picking",
                                icon : "picking.png",
                                iconSize : "",
                                routerName : "pickingfordeliveryindex"
                            },
                            {
                                name : "Delivery QI",
                                icon : "delivery-qi.png",
                                iconSize : "sm-icon",
                                routerName : "deliveryqualityinspectionindex"
                            },
                            {
                                name : "Outgoing Check",
                                icon : "outgoing-check.png",
                                iconSize : "sm-icon",
                                routerName : "outgoingcheckindex"
                            },
                            {
                                name : "Delivery Instruction",
                                icon : "delivery-instruction.png",
                                iconSize : "sm-icon",
                                routerName : "deliveryinstructionindex"
                            },
                            
                        ]
                    },
                    {
                        groupMenu : "Subcontract",
                        children : [
                            {
                                name : "Material Picking",
                                icon : "material-picking.png",
                                iconSize : "",
                                routerName : "pickingsupplyforsubcontract"
                            },
                            {
                                name : "Good Receipt",
                                icon : "good-receipt-sub-contract.png",
                                iconSize : "sm-icon",
                                routerName : "subcontractgoodreceipt"
                            },
                        ]
                    },
                    {
                        groupMenu : "Inventory",
                        children : [
                            {
                                name : "Stock Opname",
                                icon : "stock-opname.png",
                                iconSize : "sm-icon",
                                routerName : "stockopname"
                            },
                        ]
                    },
                    {
                        groupMenu : "General",
                        children : [
                            {
                                name : "Putaway",
                                icon : "putaway.png",
                                iconSize : "",
                                routerName : "putaway"
                            },
                            {
                                name : "Combine Case",
                                icon : "combine-case.png",
                                iconSize : "sm-icon",
                                routerName : "combinecase"
                            },
                        ]
                    }
                ],
                isScannerMode: true,
                idDraft: '',
                isBusy : {
                    partgoodreceipt : false,
                    partpurchasequalitycontrol : false,
                    putaway : false,
                    woexecution : false,
                    receiptfromproduction : false,
                    combinecase: false,
                    pickingsupplyforsubcontract: false,
                    subcontractgoodreceipt: false,
                    stockopname: false,
                }
            }
        },
        methods : {
            goToMenu(item) {
                if (item.routerName == "partgoodreceipt") {
                    this.scanPartGoodReceipt();
                } else if (item.routerName == "partpurchasequalitycontrol") {
                    this.scanPartPurchaseQualityControl();
                } else if (item.routerName == "putaway") {
                    this.scanPutAway();
                } else if (item.routerName == "woexecution") {
                    this.scanWorkOrderExecution();
                }  else if (item.routerName == "receiptfromproduction") {
                    this.scanReceiptFromProduction();
                } else if (item.routerName == "combinecase") {
                    this.scanCombineCase();
                } else if (item.routerName == "pickingsupplyforsubcontract") {
                    this.scanPickingSupplyForSubcontract();
                } else if (item.routerName == "subcontractgoodreceipt") {
                    this.scanSubcontractGoodReceipt();
                } else if (item.routerName == "stockopname") {
                    this.scanStockOpname();
                } else {
                    this.$router.push({ name: item.routerName });
                }
            },
            scanPartGoodReceipt() {
                this.isBusy.partgoodreceipt = true;
                PartGoodReceipt.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'partgoodreceiptedit';
                            if (this.isScannerMode) {
                                createRoute = 'partgoodreceiptscan';
                            }

                            this.$router.push({ name: createRoute, params: { id: result.id } });
                        }
                    }
                    this.isBusy.partgoodreceipt = false;
                }).catch(error => {
                    this.isBusy.partgoodreceipt = false;
                })
            },
            async scanPartPurchaseQualityControl() {
                this.isBusy.partpurchasequalitycontrol = true;
                await this.getPartPurchaseQualityControlExist();

                if (this.idDraft != '' && this.idDraft != null && this.idDraft != undefined) {
                    let createRoute = 'partpurchasequalitycontrolscan';
                    this.$router.push({ name: createRoute, params : { id: this.idDraft } });
                    this.isCreateBusy = false;
                }else{
                    PartPurchaseQualityControl.createData(this).then(result => {
                        if (result != null) {
                            if (result.id != null && result.id != "") {
                                let createRoute = 'partpurchasequalitycontroledit';
                                if(this.isScannerMode) {
                                    createRoute = 'partpurchasequalitycontrolscan';
                                }

                                this.$router.push({ name: createRoute, params : { id: result.id } });
                            }
                        }
                        this.isBusy.partpurchasequalitycontrol = false;
                    }).catch(error => {
                        this.isBusy.partpurchasequalitycontrol = false;
                    })
                }
            },
            scanPutAway() {
                this.isBusy.putaway = true;
                PutawayHeader.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'putawayscan';
                            this.$router.push({ name: createRoute, params: { id: result.id } });
                        }
                    }
                    this.isBusy.putaway = false;
                }).catch(error => {
                    this.isBusy.putaway = false;
                })
            },
            scanWorkOrderExecution() {
                this.isBusy.woexecution = true;
                WorkOrderExecution.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'workorderexecutionedit';
                            if(this.isScannerMode) {
                                createRoute = 'workorderexecutionscan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.woexecution =  false;
                }).catch(error => {
                    this.isBusy.woexecution = false;
                })
            },
            scanReceiptFromProduction() {
                this.isBusy.receiptfromproduction = true;
                ReceiptFromProduction.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'receiptfromproductionedit';
                            if(this.isScannerMode) {
                                createRoute = 'receiptfromproductionscan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.receiptfromproduction = false;
                }).catch(error => {
                    this.isBusy.receiptfromproduction = false;
                })
            },
            scanCombineCase() {
                this.isBusy.combinecase = true;
                CombineCase.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'combinecaseedit';
                            if(this.isScannerMode) {
                                createRoute = 'combinecasescan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.combinecase = false;
                }).catch(error => {
                    this.isBusy.combinecase = false;
                })
            },
            scanPickingSupplyForSubcontract() {
                this.isBusy.pickingsupplyforsubcontract = true;
                PickingSupplyForSubcontract.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'pickingsupplyforsubcontractedit';
                            if(this.isScannerMode) {
                                createRoute = 'pickingsupplyforsubcontractscan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.pickingsupplyforsubcontract = false;
                }).catch(error => {
                    this.isBusy.pickingsupplyforsubcontract = false;
                })
            },
            scanSubcontractGoodReceipt() {
                this.isBusy.subcontractgoodreceipt = true;
                SubcontractGoodReceipt.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'subcontractgoodreceiptedit';
                            if(this.isScannerMode) {
                                createRoute = 'subcontractgoodreceiptscan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.subcontractgoodreceipt = false;
                }).catch(error => {
                    this.isBusy.subcontractgoodreceipt = false;
                })
            },
            scanStockOpname() {
                this.isBusy.stockopname = true;
                StockOpname.createData(this).then(result => {
                    if (result != null) {
                        if (result.id != null && result.id != "") {
                            let createRoute = 'stockopnameedit';
                            if(this.isScannerMode) {
                                createRoute = 'stockopnamescan';
                            }

                            this.$router.push({ name: createRoute, params : { id: result.id } });
                        }
                    }
                    this.isBusy.stockopname = false;
                }).catch(error => {
                    this.isBusy.stockopname = false;
                })
            },
            getPartPurchaseQualityControlExist: async function () {
                let this_ = this;
                await this_.$http.get('PartPurchaseQualityControl/getPartPurchaseQcDraft/')
                .then(async function (response) {
                    this_.idDraft = response.data;
                })
            },
        }
    }
</script>